import React, { useRef, useState, useCallback, useMemo, useEffect } from 'react'
import FeedVideoCardItem from '../../../home/components/home-feed/item'
import FloorTags from 'Components/floor/floor-tags'
import { useResponsive } from 'Components/hooks/use-responsive'
import { getRecommendVideoList } from '../../services/index'
import Cookies from '@arsenal/arsenal/modules/Cookies'
import ScrollLoader from 'Components/scroll-loader'
import Loading from 'Components/loading'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface IProps {
  columns: number
  authorTeaParams?: { [key: string]: any }
  contentTeaParams?: { [key: string]: any }
}
const COUNT = 12
const RecommendVideo: React.FC<IProps> = ({
  columns,
  authorTeaParams = {},
  contentTeaParams = {},
}) => {
  const [tags, setTags] = useState<any>([])
  const [videoList, setVideoList] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const conditionRef = useRef<{
    id: string
    loadCount: number
    fetchId: number
    hasMore?: true
    cursor?: 0
  }>({ id: '_hot', loadCount: 0, fetchId: 0, hasMore: true, cursor: 0 })
  const timerRef = useRef<any>()

  /* 懒加载 */
  const loadMoreHandler = async (isIinit = false) => {
    if (!conditionRef?.current?.id || !conditionRef?.current?.hasMore) {
      return
    }
    setLoading(true)

    // eslint-disable-next-line no-multi-assign
    const lastFetchId = (conditionRef.current.fetchId = Math.random())

    try {
      const data = await getRecommendVideoList({
        req: null,
        type: conditionRef?.current?.id === '_hot' ? 1 : 2,
        web_id: (Cookies('tt_webid') as string) || '',
        count: isIinit ? COUNT * 2 : COUNT,
        category: 'motor_car' || '',
        cursor: conditionRef?.current?.cursor || 0,
      })
      if (conditionRef?.current?.fetchId !== lastFetchId) {
        return
      }
      if (conditionRef.current) {
        conditionRef.current.loadCount++
        conditionRef.current.hasMore = data.hasMore
        conditionRef.current.cursor = data.cursor
      }
      setVideoList([...videoList, ...(data?.list || [])])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadMoreHandler(true)
  }, [])

  const lastFetchIdRef = useRef(0)

  return (
    <div className="floor-card">
      <h2 className="title">热门资讯</h2>
      <div className={`content-wrap`}>
        <ScrollLoader
          loading={loading}
          loadMoreHandler={loadMoreHandler}
          end={false}
        >
          <div
            className="tw-grid tw-grid-cols-12 tw-gap-16 tw-gap-y-40"
            style={{ marginTop: 24 }}
          >
            {videoList?.map((item: any, index: number) => (
              <div className={`tw-col-span-${12 / columns}`} key={index}>
                <FeedVideoCardItem
                  category={conditionRef?.current?.id}
                  uniqueIdStr={item?.unique_id_str}
                  title={item?.info?.title}
                  coverUrl={item?.info?.image_list?.[0]?.url}
                  duration={item?.info?.video_duration}
                  avatar={item?.info?.user_info?.avatar_url}
                  name={item?.info?.user_info?.name}
                  publishTime={item?.info?.display_time}
                  videoWatchCount={
                    item?.info?.video_detail_info?.video_watch_count ||
                    item?.info?.read_count
                  }
                  userId={item?.info?.user_info?.user_id}
                  userVerified={
                    item?.info?.user_info?.user_verified ||
                    !!item?.info?.user_info?.motor_auth_show_info?.auth_v_type
                  }
                  verifyType={
                    item?.info?.user_info?.motor_auth_show_info?.auth_v_type
                  }
                  contentTeaParams={{
                    ...contentTeaParams,
                    rank: '',
                    author_id: `${item?.info?.user_info?.user_id}`,
                  }}
                  authorTeaParams={{
                    ...authorTeaParams,
                    author_id: `${item?.info?.user_info?.user_id}`,
                  }}
                />
              </div>
            ))}
          </div>
        </ScrollLoader>
        <div style={{ height: 50 }}>{loading ? <Loading /> : null}</div>
      </div>
      <style jsx>
        {`
          .floor-card {
          }
          .title {
            font-size: 20px;
            font-weight: 600;
            color: #1f2129;
            margin-top: 40px;
            margin-bottom: 16px;
          }
          .content-wrap {
            position: relative;
            min-height: 500px;
            padding-bottom: 20px;
          }
          .content-wrap.loading:after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.6);
          }
        `}
      </style>
    </div>
  )
}

export default RecommendVideo
